import { checkTypeScanCode } from '../../../../utils/sharedValidationUtils';

export const getFirstItem = (unScannedItems) => {
  if (unScannedItems.length > 0) {
    const firstItem = unScannedItems[0];
    if (firstItem.product_type === 'individual' && firstItem.child_items?.length > 0) {
      return firstItem.child_items[0];
    }
    return firstItem;
  }
  return null;
};

export const isFlatDisplayItem = (item) => {
  return !item || item.product_type === 'single' || item.product_type === 'depends' || !item.product_type;
};

export const findDependsChildMatch = (barcode, dependsItem) => {
  if (dependsItem?.product_type !== 'depends' || !dependsItem?.child_items?.length) {
    return null;
  }
  const lowerBarcode = barcode.toLowerCase();
  for (let i = 0; i < dependsItem.child_items.length; i++) {
    const child = dependsItem.child_items[i];
    if (child.barcodes?.some(b => b.barcode?.toLowerCase() === lowerBarcode)) {
      return { child, childIndex: i };
    }
  }
  return null;
};

export const transformDependsToIndividual = (dependsItem) => {
  const kitDivide = dependsItem.total_qty || dependsItem.qty_remaining + (dependsItem.scanned_qty || 0) || 1;
  const perRoundChildren = dependsItem.child_items.map(child => ({
    ...child,
    qty_remaining: Math.max(child.total_qty || 0, child.qty_remaining + (child.scanned_qty || 0)) / kitDivide
  }));
  return {
    ...dependsItem,
    qty_remaining: 1,
    product_type: 'individual',
    child_items: perRoundChildren,
    _kitRoundChildTemplate: perRoundChildren.map(c => ({ ...c }))
  };
};

export const applyDependsTransformation = (unScannedItems, parentIndex) => {
  const updatedItems = [...unScannedItems];
  const individualItem = transformDependsToIndividual(updatedItems[parentIndex]);
  updatedItems[parentIndex] = individualItem;
  return updatedItems;
};

export const removeItem = (unScannedItems) => {
  const firstItem = unScannedItems[0];
  if (firstItem.product_type === 'individual' && firstItem.child_items && firstItem.child_items.length > 0) {
    firstItem.child_items.shift();
    if (firstItem.child_items.length === 0) {
      unScannedItems.shift();
    }
  } else {
    unScannedItems.shift();
  }
  return unScannedItems;
};

export const findItemInAnySequence = (barcodeInput, unScannedItems) => {
  const lowerBarcode = barcodeInput.toLowerCase();

  let parentBarcodeMatch = false;
  for (let i = 0; i < unScannedItems.length; i++) {
    const item = unScannedItems[i];
    if (
      item.qty_remaining > 0 &&
      item.barcodes?.some(b => b.barcode?.toLowerCase() === lowerBarcode)
    ) {
      if (item.product_type === 'individual') {
        parentBarcodeMatch = true;
        continue;
      }
      return { item, isChildMatch: false, parentIndex: i };
    }
  }

  if (parentBarcodeMatch) {
    return null;
  }

  for (let i = 0; i < unScannedItems.length; i++) {
    const item = unScannedItems[i];
    if (!item.child_items?.length) continue;
    for (let j = 0; j < item.child_items.length; j++) {
      const child = item.child_items[j];
      if (
        child.qty_remaining > 0 &&
        child.barcodes?.some(b => b.barcode?.toLowerCase() === lowerBarcode)
      ) {
        return { item: child, isChildMatch: true, parentIndex: i, parentItem: item };
      }
    }
  }
  return null;
};

export const bulkScanItem = (item) => ({
  ...item,
  scanned_qty: (item.scanned_qty || 0) + (item.qty_remaining || 0),
  qty_remaining: 0
});

export const handleTypeScan = (state, processBarcode) => {
  const { currentItem: currentItemForTypeScan, typeScanState, currentOrder } = state.scanPackScanning;
  const { bothSettings } = state.user;
  const scanPackSettings = bothSettings?.data?.data?.scanpack_setting;
  const typeScanResult = checkTypeScanCode(processBarcode, scanPackSettings, currentItemForTypeScan, typeScanState, currentOrder);
  return typeScanResult;
};
